/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  // CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

const AddFood = () => {
  const [additions, setAdditions] = useState([{ name: "", price: "" }]);

  const addAdditions = () => {
    const addition = { name: "", price: "" };
    setAdditions(prevAdditions => [...prevAdditions, addition]);
  }
  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <h5 className="title">Cadastrar Cardápio</h5>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col className="pr-md-1" md="4">
                      <FormGroup>
                        <label>Titulo*</label>
                        <Input placeholder="Açai Nutella 500ml" type="text" />
                      </FormGroup>
                    </Col>
                    <Col className="px-md-1" md="3">
                      <FormGroup>
                        <label>Categoria*</label>
                        <Input placeholder="açai" type="text" />
                      </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="2">
                      <FormGroup>
                        <label>Preço*</label>
                        <Input placeholder="22.50" />
                      </FormGroup>
                    </Col>
                    <Col className="pr-md-1" md="3">
                      <FormGroup>
                        <label>Tipo</label>
                        <Input placeholder="Especial" type="text" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-md-1" md="6">
                      <FormGroup>
                        <label>Ingredientes*</label>
                        <Input
                          placeholder="açai, nutella, leite condesado, leite em pó, parçoca"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="6">
                      <FormGroup>
                        <label>Descrição</label>
                        <Input placeholder="Promoção hoje" type="text" />
                      </FormGroup>
                    </Col>
                  </Row>

                  {additions.map((item, index) => (
                  <Row key={index} style={{ justifyContent: "flex-start" }}>
                    <Col className="pr-md-1" md="3">
                      <FormGroup>
                        <label>Acrescimo</label>
                        <Input placeholder="parçoca" type="text" />
                      </FormGroup>
                    </Col>
                    <Col className="px-md-1" md="1">
                      <FormGroup>
                        <label>Valor</label>
                        <Input placeholder="1.50" type="text" />
                      </FormGroup>
                    </Col>
                    <Col
                      className="px-md-1"
                      md="1"
                      style={{ alignItems: "center", display: "flex" }}
                    >
                        {index === additions.length -1 && 
                            <Button onClick={addAdditions} style={{ color: "#eee" }}>
                                <i className="tim-icons icon-simple-add"></i>
                            </Button>
                        }
                    </Col>
                  </Row>
                  ))}
                  {/* <Row>
                    <Col md="8">
                      <FormGroup>
                        <label>About Me</label>
                        <Input
                          cols="80"
                          defaultValue="Lamborghini Mercy, Your chick she so thirsty, I'm in
                            that two seat Lambo."
                          placeholder="Here can be your description"
                          rows="4"
                          type="textarea"
                        />
                      </FormGroup>
                    </Col>
                  </Row> */}
                </Form>
              </CardBody>
              <CardFooter>
                <Button className="btn-fill" color="primary" type="submit">
                  Save
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddFood;
